import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useLayoutEffect, useState } from 'react';
import { userVerifyResend } from '../../api/Verfiy';
import { message } from 'antd';
import emailVerifyIcon from '../../assets/images/icons/icon-email@2x.png';

const PageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 181px);
  display: flex;
  justify-content: center;
  margin-top:5%;
`;

const VerifyAreaWrap = styled.div`
  width: 100%;
  height: 100%;
  max-width: 418px;
  max-height: 198px;
  background-color: #fff;
  border: 1px solid #454545;
  border-radius: 5px;
  padding: 30px;
  color: #000;
`;

const VerifyArea = styled.div`
  width: 100%;
  height: 100%;
`

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`
const VerifyIcon = styled(FlexCenter)`
  float:left;
  img {
    width:35px;
    height:28px;
  }
`
const VerifyContent = styled.div`
  float:left;
  max-width:270px;
  margin-left:32px;
`

const VerifyText = styled.p`
  font-size: 15px;
  line-height:15px;
  font-weight: bold;
`;

const VerifyP = styled.p`
  font-size: 13px;
  color: #666666;
  line-height: 18px;
`;

const EmailLink = styled.a`
  font-size: 14px;
  line-height: 24px;
  text-decoration: underline;
  &:hover{
    color:#6EE6C6;
    text-decoration: underline;
  }
`;

const VerifyEmail = () => {
  const location = useLocation();
  const [name, setName] = useState('');

  useLayoutEffect(() => {
    try {
      let { userName } = location.state;
      setName(userName);
    } catch (error) {
      // console.log(error);
    }
  });

  const resendEmail = async () => {
    try {
      const { code } = await userVerifyResend({ email: name });
      if (code === '10000') {
        message.success('Mail sent successfully');
      }
    } catch (error) {
      // console.log(error);
    }
  };
  return (
    <PageContainer>
      <VerifyAreaWrap>
        <VerifyArea>
          <VerifyIcon>
            <img src={emailVerifyIcon} />
          </VerifyIcon>
          <VerifyContent>
            <VerifyText>Please Verify Your Email Address</VerifyText>
            <VerifyP>
              An email been sent to
              {' ' + name + ' '}
              with a link to verify your account.
            </VerifyP>
            <EmailLink onClick={resendEmail}>Resend Verification Email</EmailLink>
          </VerifyContent>
        </VerifyArea>
          
            
      </VerifyAreaWrap>
    </PageContainer>
  );
};

export default VerifyEmail;
